// Catálogo dos tipos de item que a loja pode cadastrar, e o rótulo de cada
// categoria. É dado de tela, não regra: só a lista.

export const ITEM_TYPES = [
  {
    id: 1,
    name: "PDV Web",
    description: "Ponto de Venda Web",
    icon: "point_of_sale",
    category: "pdv",
    orientation: "paisagem",
  },
  {
    id: 2,
    name: "PDV Mobile",
    description: "Ponto de Venda Mobile",
    icon: "smartphone",
    category: "pdv",
    orientation: "retrato",
  },
  {
    id: 3,
    name: "Terminal de Autoatendimento",
    description: "Terminal para clientes",
    icon: "touch_app",
    category: "pdv",
    orientation: "paisagem",
  },
  {
    id: 4,
    name: "Terminal de Pagamento",
    description: "Terminal de pagamento",
    icon: "credit_card",
    category: "pdv",
    orientation: "paisagem",
  },
  {
    id: 5,
    name: "Mesa",
    description: "Mesa para atendimento",
    icon: "table_restaurant",
    category: "mobilia",
  },
  {
    id: 6,
    name: "Balcão",
    description: "Balcão de atendimento",
    icon: "countertops",
    category: "mobilia",
  },
  {
    id: 7,
    name: "Cadeira",
    description: "Cadeira para clientes",
    icon: "chair",
    category: "mobilia",
  },
  {
    id: 8,
    name: "Bancada",
    description: "Bancada de preparo",
    icon: "kitchen",
    category: "mobilia",
  },
  {
    id: 9,
    name: "Estante",
    description: "Estante para produtos",
    icon: "shelves",
    category: "mobilia",
  },
  {
    id: 10,
    name: "Vitrine",
    description: "Vitrine de exibição",
    icon: "storefront",
    category: "mobilia",
  },
  {
    id: 11,
    name: "Impressora de Conferência",
    description: "Impressora para conferência",
    icon: "print",
    category: "equipamento",
  },
  {
    id: 12,
    name: "Impressora de Produção",
    description: "Impressora para produção",
    icon: "print",
    category: "equipamento",
  },
  {
    id: 13,
    name: "Impressora Fiscal",
    description: "Impressora fiscal",
    icon: "receipt_long",
    category: "equipamento",
  },
  {
    id: 14,
    name: "Leitor de Código de Barras",
    description: "Leitor de código de barras",
    icon: "qr_code_scanner",
    category: "equipamento",
  },
  {
    id: 15,
    name: "Balança",
    description: "Balança para pesagem",
    icon: "scale",
    category: "equipamento",
  },
  {
    id: 16,
    name: "Data Collector",
    description: "Coletor de dados",
    icon: "scanner",
    category: "equipamento",
  },
  {
    id: 17,
    name: "Fogão Industrial",
    description: "Fogão para cozinha",
    icon: "stove",
    category: "cozinha",
  },
  {
    id: 18,
    name: "Forno Industrial",
    description: "Forno industrial",
    icon: "oven_gen",
    category: "cozinha",
  },
  {
    id: 19,
    name: "Geladeira",
    description: "Geladeira ou freezer",
    icon: "kitchen",
    category: "cozinha",
  },
  {
    id: 20,
    name: "Fryer",
    description: "Fritadeira industrial",
    icon: "deep_fryer",
    category: "cozinha",
  },
  {
    id: 21,
    name: "Máquina de Bebidas",
    description: "Máquina de bebidas",
    icon: "local_cafe",
    category: "cozinha",
  },
  {
    id: 22,
    name: "Liquidificador Industrial",
    description: "Liquidificador industrial",
    icon: "blender",
    category: "cozinha",
  },
  {
    id: 23,
    name: "Tablet de Atendimento",
    description: "Tablet para atendimento",
    icon: "tablet",
    category: "tecnologia",
  },
  {
    id: 24,
    name: "Display de Pedidos",
    description: "Display para pedidos",
    icon: "tv",
    category: "tecnologia",
  },
  {
    id: 25,
    name: "Monitor de Cozinha",
    description: "Monitor para cozinha",
    icon: "desktop_windows",
    category: "tecnologia",
  },
  {
    id: 26,
    name: "Roteador Wi-Fi",
    description: "Roteador wireless",
    icon: "router",
    category: "tecnologia",
  },
  {
    id: 27,
    name: "Switch de Rede",
    description: "Switch de rede",
    icon: "device_hub",
    category: "tecnologia",
  },
  {
    id: 28,
    name: "Access Point",
    description: "Access point Wi-Fi",
    icon: "wifi",
    category: "tecnologia",
  },
  {
    id: 29,
    name: "Caixa Registradora",
    description: "Caixa registradora",
    icon: "point_of_sale",
    category: "caixa",
  },
  {
    id: 30,
    name: "Gaveta de Dinheiro",
    description: "Gaveta para dinheiro",
    icon: "money",
    category: "caixa",
  },
  {
    id: 31,
    name: "Detector de Notas",
    description: "Detector de cédulas",
    icon: "currency_exchange",
    category: "caixa",
  },
  {
    id: 32,
    name: "Ar Condicionado",
    description: "Ar condicionado",
    icon: "ac_unit",
    category: "ambiente",
  },
  {
    id: 33,
    name: "Ventilador",
    description: "Ventilador",
    icon: "mode_fan",
    category: "ambiente",
  },
  {
    id: 34,
    name: "Aquecedor",
    description: "Aquecedor",
    icon: "heat",
    category: "ambiente",
  },
  {
    id: 35,
    name: "Sistema de Som",
    description: "Sistema de áudio",
    icon: "speaker",
    category: "ambiente",
  },
  {
    id: 36,
    name: "Câmera de Segurança",
    description: "Câmera de segurança",
    icon: "videocam",
    category: "ambiente",
  },
  {
    id: 37,
    name: "Carrinho de Compras",
    description: "Carrinho de compras",
    icon: "shopping_cart",
    category: "auxiliar",
  },
  {
    id: 38,
    name: "Cesta de Compras",
    description: "Cesta de compras",
    icon: "shopping_basket",
    category: "auxiliar",
  },
  {
    id: 39,
    name: "Suporte para Tablets",
    description: "Suporte para tablets",
    icon: "tablet_mac",
    category: "auxiliar",
  },
  {
    id: 40,
    name: "Suporte para Smartphones",
    description: "Suporte para celulares",
    icon: "smartphone",
    category: "auxiliar",
  },
];

export const ROTULOS_DE_CATEGORIA: Record<string, string> = {
  pdv: "Sistemas de Venda",
  mobilia: "Mobília e Decoração",
  equipamento: "Equipamentos",
  cozinha: "Cozinha e Preparo",
  tecnologia: "Tecnologia e Rede",
  caixa: "Caixa e Pagamento",
  ambiente: "Ambiente e Conforto",
  auxiliar: "Itens Auxiliares",
};
